import { Box, Heading } from "@chakra-ui/react";
import {
    PieChart,
    Pie,
    Tooltip,
    Legend,
    ResponsiveContainer,
    Cell
} from "recharts";
import { useColorModeValue } from "../../ui/color-mode";
import { darkMode, lightMode } from "../../../theme/config";

const defaultColors = ["red", "green", "blue", "purple", "orange"];

const CustomTooltip = ({ active, payload }) => {
    const bgColor = useColorModeValue(lightMode.boxBackgroundColor, darkMode.boxBackgroundColor);
    if (active && payload && payload.length) {
        const { name, value } = payload[0];
        return (
            <div style={{ backgroundColor: bgColor, padding: "5px", border: "1px solid #ccc" }}>
                <strong>{name}</strong>
                <div>Value: {value}</div>
            </div>
        );
    }

    return null;
};

const PieChartRepresentation = ({
    title,
    subTitle,
    data,
    colors = defaultColors,
    outerRadius = "70%"
}) => {

    const renderCustomizedLabel = ({
        cx, cy, midAngle, innerRadius, outerRadius, percent, index, name
    }) => {
        const RADIAN = Math.PI / 180;
        const radius = outerRadius + 20;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);
        const alignment = x > cx ? 'start' : 'end';

        const labelColor = colors[index % colors.length];

        return (
            <text
                x={x}
                y={y}
                fill={labelColor}
                textAnchor={alignment}
                dominantBaseline="central"
                style={{ fontSize: '12px' }}
            >
                {`${name}: ${(percent * 100).toFixed(0)}%`}
            </text>
        );
    };



    const bgColor = useColorModeValue(lightMode.boxBackgroundColor, darkMode.boxBackgroundColor);
    const datapoints = data || {};
    return (
        <Box
            bg={bgColor}
            boxShadow="md"
            borderRadius="md"
            p={4}
            m={2}
            width="full"
            maxW="600px"
        >
            <Heading size="xl" textAlign="start">
                {title}
            </Heading>
            <Heading size="sm" textAlign="start" color="gray.500" pb={2}>
                {subTitle}
            </Heading>

            <Box width="100%" height={{ base: 300, md: 280 }}>
                <ResponsiveContainer>
                    <PieChart>
                        <Pie
                            data={datapoints}
                            dataKey="count"
                            nameKey="value"
                            cx="50%"
                            cy="50%"
                            outerRadius={outerRadius}
                            fontSize={2}
                            label={renderCustomizedLabel}
                        >
                            {datapoints.map((entry, index) => (
                                <Cell
                                    key={`cell-${index}`}
                                    fill={colors[index % colors.length]}
                                />
                            ))}
                        </Pie>
                        {/* A custom tooltip for more control over styling and displayed info */}
                        <Tooltip content={<CustomTooltip />} />
                        <Legend
                            verticalAlign="bottom"
                            iconType="circle"
                            wrapperStyle={{ fontSize: "14px" }}
                        />
                    </PieChart>
                </ResponsiveContainer>
            </Box>
        </Box>
    );
};

export default PieChartRepresentation;
